module.exports = __webpack_public_path__ + "static/img/banner-1.0a8ec546.png";